module.exports = __webpack_public_path__ + "a37106bd9119632053d0f360ef7eeade.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a2p-2.png
// module id = 838
// module chunks = 0